import {jsxs as _jsxs, jsx as _jsx} from "react/jsx-runtime";import styled from '@emotion/styled'
import graphql from 'babel-plugin-relay/macro'
import {useFragment} from 'react-relay'

import useDocumentTitle from '../hooks/useDocumentTitle'
import useRouter from '../hooks/useRouter'
import DialogContent from './DialogContent'
import DialogTitle from './DialogTitle'
import GoogleOAuthButtonBlock from './GoogleOAuthButtonBlock'
import InvitationCenteredCopy from './InvitationCenteredCopy'
import InvitationDialogCopy from './InvitationDialogCopy'
import InviteDialog from './InviteDialog'





const TeamName = styled('span')({
  fontWeight: 600,
  whiteSpace: 'nowrap'
})

const TeamInvitationGoogleSignin = (props) => {
  const {match} = useRouter()
  const {params} = match
  const {token: invitationToken} = params
  const {verifiedInvitation: verifiedInvitationRef} = props
  const verifiedInvitation = useFragment(
    graphql`
      fragment TeamInvitationGoogleSignin_verifiedInvitation on VerifiedInvitationPayload {
        meetingName
        user {
          email
          preferredName
        }
        teamName
      }
    `,
    verifiedInvitationRef
  )
  const {meetingName, user, teamName} = verifiedInvitation
  useDocumentTitle(`Sign in with Google | Team Invitation`, 'Sign in')

  if (!user) return null
  const {email, preferredName} = user
  return (
    _jsxs(InviteDialog, { children: [
      _jsxs(DialogTitle, { children: ["Welcome back, "  , preferredName, "!"]})
      , _jsxs(DialogContent, { children: [
        _jsx(InvitationDialogCopy, { children: "You last signed in with Google. "      })
        , _jsxs(InvitationDialogCopy, { children: ["Tap below"

          , meetingName ? ` to join ${meetingName} for: ` : ' for immediate access to your team: '
          , _jsx(TeamName, { children: teamName})
        ]})
        , _jsx(InvitationCenteredCopy, { children: 
          _jsx(GoogleOAuthButtonBlock, { loginHint: email, invitationToken: invitationToken,} )
        })
      ]})
    ]})
  )
}

export default TeamInvitationGoogleSignin
